// extracted by mini-css-extract-plugin
export default {"container":"socialMediaSettings_container__n0kIz","linksWrapper":"socialMediaSettings_linksWrapper__l6v3j","linkWrapper":"socialMediaSettings_linkWrapper__8IaAr"};